import React, { useState, useEffect } from "react";
import styles from "./SelectedReturn.module.css";
import { useFont } from "../../contexts/FontContext/FontContext";
import { trackingColors, getCarrier } from "../utils/common";

const SelectedReturn = ({ data, setSelectedReturn, isExchange, token }) => {
	const apiUrl = process.env.REACT_APP_API_URL;
	const fontSchemes = useFont();
  	const fontFamilyOne = fontSchemes.scheme_one;
  	const [error, setError] = useState(null);
  	const [loadingRefund, setLoadingRefund] = useState(false);
  	const [revealPopUp, setRevealPopUp] = useState(false);
  	const [viewLabel, setViewLabel] = useState(false);
  	const [refundLabel, setRefundLabel] = useState(false);
  	const [refundStatus, setRefundStatus] = useState(false);
  	const [carrierName, setCarrierName] = useState("");
  	const [itemsToShow, setItemsToShow] = useState("returns");
  	const [wmsToggleState, setWmsToggleState] = useState(data.show_in_wms);

  	const labelData = {
  		"Brand": data.business_name,
  		"Tracking status": data.tracking_status.replace(/_/g, " ").replace(/^\w/, (char) => char.toUpperCase()),
  		"Delivered at": data.delivered_at ? data.delivered_at.split("T")[0] : null,
  		"Tracking number": data.tracking_number,
  		"Customer name": data.customer_name,
  		"Customer email": data.customer_email,
  		"Date of label purchase": data.date_purchased.split("T")[0], //extract date
  		"Label cost": '$' + Number(data.label_cost).toFixed(2),
  		"Label purchase price": '$' + Number(data.label_purchase_price).toFixed(2),
  		"Weight": data.weight,
  	};	

  	//set carrier name
  	useEffect(() => { setCarrierName(getCarrier(data.carrier_name)); }, []);

  	//check refund status
  	useEffect(() => {
	    if (data.refund_status?.toLowerCase() === "submitted") { setRefundStatus("Void submitted."); }
	    else if (data.refund_status?.toLowerCase() === "refunded") { setRefundStatus("Voided."); }
	}, [data.refund_status]); 

  	// get toggle state on mount
	useEffect(() => {
	const fetchToggleState = async () => {
		try {
		  	const response = await fetch(`${apiUrl}/api/get_wms_order_toggle/`, {
		    	method: "POST",
		    	headers: {
		      		"Content-Type": "application/json",
		     		Authorization: `Bearer ${token}`,
		    	},
		    	body: JSON.stringify({ return_token: data.token }),
		  	});
		  const toggle_data = await response.json();
		  setWmsToggleState(toggle_data.show_in_wms);
		} catch (error) { console.error("Error fetching toggle state:", error); }
	};
	fetchToggleState();
	}, [token]);

  	// toggle state when clicked
	const handleToggle = async () => {
    	try {
      		const response = await fetch(`${apiUrl}/api/create_wms_order_toggle/`, {
        		method: "POST",
        		headers: {
          			"Content-Type": "application/json",
          			Authorization: `Bearer ${token}`,
        		},
        		body: JSON.stringify({ return_token: data.token }),
      		});
      		const toggle_data = await response.json();
      		setWmsToggleState(toggle_data.show_in_wms);
    	} catch (error) { console.error("Error toggling:", error); }
  	};

  	const handleLabelButtonClick = (button) => {
  		if (button === "view" && !data.label_url.endsWith(".pdf")) {  
  			setRevealPopUp(true);
  			setViewLabel(true);
  			setRefundLabel(false);
  		}
  		else if (button === "download" || (button === "view" && data.label_url.endsWith(".pdf"))) {
  			setRevealPopUp(false);
  			setViewLabel(false);
  			setRefundLabel(false);
  			window.open(data.label_url, "_blank", "noopener,noreferrer");
  		} else if (button === "refund") {
  			setRevealPopUp(true);
  			setRefundLabel(true);
  			setViewLabel(false);
  		} else {setRevealPopUp(false); }
  	}

  	const handleRefund = async (shipment_id) => {
  		setLoadingRefund(true);
	    try {
	        const response = await fetch(`${apiUrl}/api/refund_label/`, {
	            method: "POST",
	            headers: {
	                "Content-Type": "application/json",
	                 Authorization: `Bearer ${localStorage.getItem("authToken")}`,
	            },
	            body: JSON.stringify({ shipment_id }),
	        });
	        const result = await response.json();
	        if (!response.ok) { setError(result.error); }
	        else { setRefundStatus("Refund submitted."); }
	    } catch (error) { console.error("Error refunding label:", error); }
	    finally { setLoadingRefund(false); }
	};
 
	return (
		<div className={styles.selected_return_container}>
			<p className={`titles ${styles.selected_return_title} ${fontFamilyOne} fade_in`}>Showing {isExchange ? "exchange" : "return"} details for order #{data.order_id}</p>
			<div className={`${styles.selected_return_box} fade_in`}>
				<div className={styles.product_carrier_row}>
					<div className={`${styles.products_box} ${((itemsToShow === "returns" ? data.products : data.new_items).length > 1 ? styles.products_box_scroll : styles.products_box_no_scroll)}`}>
						{data.products.length !== 0 && (
							(itemsToShow === "returns" ? data.products : data.new_items).map((product, index) => (
								<div key={index} className={`${styles.product_row} ${index !== data.products.length - 1 ? "bottom_box_shadow" : ""}`}>	
									<div className={styles.product_name_wrapper}>	
										<p className={`${styles.product_name}`}>{product.product_title + `${product.product_title === 'Flosser Box' ? '' : '/ ' }`} {product.product_variant === "Default Title" ? "" : product.product_variant} {product.product_quantity > 1 ? `(${product.product_quantity})` : ""}</p>
									</div>
									<div className={styles.product_image_wrapper}>
										{product.product_title !== 'Flosser Box' ? <img src={product.product_image} className={styles.product_image} alt={product.product_title} /> : <img src={`${process.env.PUBLIC_URL}/images/flosser_box.png`} className={styles.product_image} alt={product.product_title} />}
									</div>
								</div>
							))
						)}
						{data.products.length === 0 && (<p className={styles.created_in_generator_text}>Created in label generator.</p>)}
					</div>
					<div className={styles.carrier_box}>
						<p className={`${styles.carrier_name}`}>{carrierName}</p>
						<img src={`${process.env.PUBLIC_URL}/images/${carrierName.toLowerCase()}_logo.png`} className={styles.carrier_image} alt="carrier_image"/>
						<p className={`${styles.carrier_service}`}>{data.carrier_service}</p>
					</div>
				</div>
				<div className={`${styles.data_and_label_buttons_row}`}>
					<div className={`${styles.data_box} ${data.products.length === 0 ? styles.shift : ""}`}>
						<>
							{isExchange && (
								<div className={styles.items_toggle_wrapper}>
									<div className={styles.items_toggle}>
										<div className={`${styles.items_option} ${itemsToShow === "returns" ? styles.highlighted : ""}`} onClick={() => { setItemsToShow("returns"); }} style={{ borderTopLeftRadius: '5px', borderBottomLeftRadius: '5px' }}>Returned</div>
										<div className={`${styles.items_option} ${itemsToShow === "exchanges" ? styles.highlighted : ""}`} onClick={() => { setItemsToShow("exchanges"); }} style={{ borderTopRightRadius: '5px', borderBottomRightRadius: '5px' }}>New</div>
									</div>
									<p className={styles.items_option_text}>{itemsToShow === "returns" ? "returned items" : "new items chosen"} </p>
								</div>
								
							)}
							{/*Don't show label purchase price for exchanges because it is the same*/}
							{Object.entries(labelData).map(([key, value], index) => (
								((isExchange && key === "Label purchase price") || (data.products.length === 0 && key === "Label purchase price") || !value) ? null : (
							        <div key={index} className={styles.data_row}>
							        	<div className={styles.data_key_wrapper}>
							            	<p>{key}:</p>
							            </div>
							            <div className={styles.data_value_wrapper}>
							            	<p style={{color: key === "Tracking status" && trackingColors[data.tracking_status] }}>{value}{key === "Weight" ? "oz." : ""}</p>
							            </div>
							        </div>
							    )
						    ))}
						    {/*styling for package dimensions is slightly different, so it gets its own wrapper*/}
						    <div className={styles.data_row}>
						    	<div className={styles.data_key_wrapper}>
						    		<p className={styles.package_dimensions_label}>Package dimensions:</p>
						    	</div>
						    	<div className={`${styles.package_dimensions}`}>
							    	<p>Length: &nbsp;{data.package_dimensions.length}in.</p>
							    	<p>Width: &nbsp;{data.package_dimensions.width}in.</p>
							    	<p>Height: &nbsp;{data.package_dimensions.height}in.</p>
							    </div>
						    </div>
						</>
					</div>
					<div className={styles.label_buttons_box}>
						<div className={styles.label_buttons} onClick={() => handleLabelButtonClick("view")}>View label</div>
						<div className={styles.label_buttons} onClick={() => handleLabelButtonClick("download")}>Download</div>
						<div className={`${styles.label_buttons} ${styles.refund}`} onClick={() => handleLabelButtonClick("refund")}>Void</div>
						{isExchange && (
							<div className={styles.write_to_wms_toggle_box}>
								<p className={styles.write_to_wms_text}>Create order in WMS</p>
								<img className={styles.write_to_wms_toggle} src={`${process.env.PUBLIC_URL}/images/${wmsToggleState ? "toggle_on.png" : "toggle_off.png"}`} alt="wms_toggle" onClick={() => handleToggle()} />
							</div>
						)}
						{revealPopUp && (
							<div className={styles.pop_up}>
								{loadingRefund ? (<img className={styles.refund_purchase_loader} src={`${process.env.PUBLIC_URL}/images/shipwheel_loader.gif`} alt="Loading Refund" />)
								: (
									<>
										<img src={`${process.env.PUBLIC_URL}/images/remove_popup.png`} className="remove_popup" onClick={() => handleLabelButtonClick("remove")} alt="remove_label_button_popup"/>
										{viewLabel && (<img src={data.label_url} className={styles.label_image} alt="label_image"/>)}
										{refundLabel && (
											error ? (<p className="error_message">{error}</p>)										
											: (
												<>
													{refundStatus ? <p className={styles.refund_label_confirm_text}>Refund submitted.</p> : <p className={styles.refund_label_confirm_text}>Void this label?</p>}
													<img src={data.label_url} className={styles.label_refund_image} alt="label_image"/>
													{!refundStatus && <div className={styles.refund_label_confirm_button} onClick={() => handleRefund(data.shipment_id)}>Confirm</div>}
												</>
											)
										)}
									</>
								)}
							</div>
						)}
					</div>
				</div>
			</div>
			<button onClick={() => setSelectedReturn(null)} className={`back_buttons ${styles.selected_return_back_button}`}>
				 <img src={`${process.env.PUBLIC_URL}/images/back_button_arrow.png`} className={styles.selected_return_back_button_arrow} alt="back"/>
			</button>
		</div>
	);
};

export default SelectedReturn;